import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Cookie, Settings, BarChart3, Users, Clock, Shield } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PoliticaCookiesPage = () => {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a]">
        <div className="max-w-4xl mx-auto px-6">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/60 hover:text-white transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" />
            Volver al inicio
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-12 h-12 rounded-full bg-[#e4002b]/20 flex items-center justify-center">
              <Cookie className="w-6 h-6 text-[#e4002b]" />
            </div>
            <h1 className="text-3xl md:text-4xl font-bold">Política de Cookies</h1>
          </div>
          
          <p className="text-white/60 text-sm">
            Última actualización: Febrero 2026
          </p>
        </div>
      </section>
      
      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-6">
          <div className="space-y-10">
            
            {/* Section 1 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">1</span>
                ¿QUÉ SON LAS COOKIES?
              </h2>
              <p className="text-white/70 leading-relaxed">
                Una cookie es un fichero que se descarga en su ordenador o dispositivo al acceder a determinadas páginas web. Las cookies permiten a una página web, entre otras cosas, almacenar y recuperar información sobre los hábitos de navegación de un usuario o de su equipo y, dependiendo de la información que contengan y de la forma en que utilice su equipo, pueden utilizarse para reconocer al usuario.
              </p>
            </div>
            
            {/* Section 2 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">2</span>
                ¿QUÉ TIPOS DE COOKIES UTILIZA ESTA PÁGINA WEB?
              </h2>
              
              <p className="text-white/70 mb-6 leading-relaxed">
                www.cinemastreaming.es utiliza las siguientes tipologías de cookies:
              </p>
              
              <div className="grid gap-4">
                <div className="bg-[#0a0a0a] rounded-lg p-5 border border-white/5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-blue-500/20 flex items-center justify-center">
                      <Settings className="w-5 h-5 text-blue-400" />
                    </div>
                    <h3 className="font-semibold text-white">Cookies técnicas</h3>
                  </div>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Son aquellas que permiten al usuario la navegación a través de la página web y la utilización de las diferentes opciones o servicios que en ella existen, como controlar el tráfico y la comunicación de datos, identificar la sesión o acceder a partes de acceso restringido.
                  </p>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-5 border border-white/5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-purple-500/20 flex items-center justify-center">
                      <Users className="w-5 h-5 text-purple-400" />
                    </div>
                    <h3 className="font-semibold text-white">Cookies de personalización</h3>
                  </div>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Permiten al usuario acceder al servicio con algunas características de carácter general predefinidas en función de una serie de criterios en el terminal del usuario (ej. el idioma).
                  </p>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-5 border border-white/5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
                      <BarChart3 className="w-5 h-5 text-green-400" />
                    </div>
                    <h3 className="font-semibold text-white">Cookies de análisis</h3>
                  </div>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Son aquellas que, tratadas por nosotros o por terceros, nos permiten cuantificar el número de usuarios y realizar la medición y análisis estadístico de la utilización que hacen los usuarios del servicio ofertado. Para ello se analiza su navegación en nuestra página web con el fin de mejorar la oferta de productos o servicios que le ofrecemos.
                  </p>
                </div>
                
                <div className="bg-[#0a0a0a] rounded-lg p-5 border border-white/5">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-10 h-10 rounded-full bg-orange-500/20 flex items-center justify-center">
                      <Users className="w-5 h-5 text-orange-400" />
                    </div>
                    <h3 className="font-semibold text-white">Cookies de terceros</h3>
                  </div>
                  <p className="text-white/60 text-sm leading-relaxed">
                    Esta web puede utilizar servicios de terceros (como Google Analytics) que recopilarán información con fines estadísticos y de uso del sitio por parte del usuario.
                  </p>
                </div>
              </div>
            </div>
            
            {/* Section 3 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">3</span>
                DETALLE DE COOKIES UTILIZADAS
              </h2>
              
              <p className="text-white/70 mb-6 leading-relaxed">
                A continuación, se detallan las cookies utilizadas en este portal:
              </p>
              
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-white/10">
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Nombre</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Proveedor</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Finalidad</th>
                      <th className="text-left py-3 px-4 text-white/50 font-medium">Duración</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-white/5">
                    <tr>
                      <td className="py-3 px-4 text-white font-mono">_ga</td>
                      <td className="py-3 px-4 text-white/70">Google Analytics</td>
                      <td className="py-3 px-4 text-white/70">Registro de visitas únicas con fines estadísticos.</td>
                      <td className="py-3 px-4 text-white/70">2 años</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 text-white font-mono">_gid</td>
                      <td className="py-3 px-4 text-white/70">Google Analytics</td>
                      <td className="py-3 px-4 text-white/70">Agrupación del comportamiento del usuario.</td>
                      <td className="py-3 px-4 text-white/70">24 horas</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 text-white font-mono">session_id</td>
                      <td className="py-3 px-4 text-white/70">Propia</td>
                      <td className="py-3 px-4 text-white/70">Mantener la sesión del usuario abierta (técnica).</td>
                      <td className="py-3 px-4 text-white/70">Sesión</td>
                    </tr>
                    <tr>
                      <td className="py-3 px-4 text-white font-mono">cookie_consent</td>
                      <td className="py-3 px-4 text-white/70">Propia</td>
                      <td className="py-3 px-4 text-white/70">Recordar si el usuario aceptó la política de cookies.</td>
                      <td className="py-3 px-4 text-white/70">1 año</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            
            {/* Section 4 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">4</span>
                CONSENTIMIENTO Y CONFIGURACIÓN
              </h2>
              <div className="text-white/70 space-y-4 leading-relaxed">
                <p>
                  El usuario puede aceptar, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador.
                </p>
                <p>
                  Al navegar por primera vez por nuestra web, aparecerá un panel donde podrá elegir qué cookies desea instalar. En cualquier momento puede volver a cambiar su configuración desde el enlace de "Configuración de Cookies" situado en el pie de página.
                </p>
              </div>
            </div>
            
            {/* Section 5 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">5</span>
                CÓMO DESACTIVAR LAS COOKIES EN LOS PRINCIPALES NAVEGADORES
              </h2>
              
              <p className="text-white/70 mb-6 leading-relaxed">
                Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las opciones del navegador instalado en su ordenador:
              </p>
              
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-2">Google Chrome</h4>
                  <p className="text-white/60 text-sm">Configuración {'>'} Privacidad y seguridad {'>'} Cookies y otros datos de sitios.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-2">Mozilla Firefox</h4>
                  <p className="text-white/60 text-sm">Ajustes {'>'} Privacidad y Seguridad {'>'} Cookies y datos del sitio.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-2">Safari</h4>
                  <p className="text-white/60 text-sm">Preferencias {'>'} Privacidad {'>'} Bloquear todas las cookies.</p>
                </div>
                <div className="bg-[#0a0a0a] rounded-lg p-4 border border-white/5">
                  <h4 className="font-semibold text-white mb-2">Microsoft Edge</h4>
                  <p className="text-white/60 text-sm">Configuración {'>'} Cookies y permisos del sitio.</p>
                </div>
              </div>
              
              <div className="bg-amber-500/10 border border-amber-500/30 rounded-lg p-4 mt-6">
                <p className="text-amber-200 text-sm">
                  Si opta por bloquear las cookies en su navegador, es posible que algunos servicios o funcionalidades de la página web no estén disponibles.
                </p>
              </div>
            </div>
            
            {/* Section 6 */}
            <div className="bg-[#141414] rounded-xl p-8 border border-white/10">
              <h2 className="text-xl font-bold text-[#e4002b] mb-6 flex items-center gap-3">
                <span className="w-8 h-8 rounded-full bg-[#e4002b]/20 flex items-center justify-center text-sm">6</span>
                ACTUALIZACIONES Y CAMBIOS EN LA POLÍTICA DE COOKIES
              </h2>
              <p className="text-white/70 leading-relaxed">
                Versión Digital S.L. puede modificar esta Política de Cookies en función de nuevas exigencias legislativas, reglamentarias, o con la finalidad de adaptar dicha política a las instrucciones dictadas por la Agencia Española de Protección de Datos.
              </p>
            </div>
            
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PoliticaCookiesPage;
